
import { Button } from '../ui/button';
import { NavItem } from '../../types/navigation';
import { useNavigate } from 'react-router-dom';

interface DesktopNavigationProps {
  navItems: NavItem[];
  handleNavigation: (href: string, isExternal?: boolean) => void;
}

const DesktopNavigation = ({ navItems, handleNavigation }: DesktopNavigationProps) => {
  const navigate = useNavigate();
  
  // Add debug logging to check navItems on each render
  console.log('Desktop Navigation items:', navItems);
  
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string, isInternal?: boolean) => {
    e.preventDefault();
    console.log('Desktop nav item clicked:', href);
    
    if (isInternal || href.startsWith('/')) {
      handleNavigation(href);
    } else {
      // For external links, use the default behavior
      window.open(href, '_blank');
    }
  };
  
  return (
    <nav className="hidden md:flex items-center space-x-8">
      {navItems.map((item) => {
        // For internal routes like /blog or /portfolio
        if (item.isInternal || (item.href.startsWith('/') && !item.href.includes('#'))) {
          return (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => handleClick(e, item.href, item.isInternal)}
              className="text-elegant-800 hover:text-elegant-600 text-sm tracking-wider uppercase transition-colors duration-300"
              data-persistent={item.isPersistent ? 'true' : 'false'}
            >
              {item.label}
            </a>
          );
        }
        
        // For anchor links like #about or #process
        if (item.href.startsWith('#')) {
          return (
            <button
              key={item.label}
              onClick={() => handleNavigation(item.href)}
              className="text-elegant-800 hover:text-elegant-600 text-sm tracking-wider uppercase transition-colors duration-300"
            >
              {item.label}
            </button>
          );
        }
        
        // External links
        return (
          <a
            key={item.label}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-elegant-800 hover:text-elegant-600 text-sm tracking-wider uppercase transition-colors duration-300"
          >
            {item.label}
          </a>
        );
      })}
      <Button
        variant="navy"
        onClick={() => handleNavigation('/kontakt')}
      >
        Kontakt
      </Button>
    </nav>
  );
};

export default DesktopNavigation;
